import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Rx'
import { profile, amend, confirm } from 'store/services/profile'
import { alertSuccess, alertErrorDefault } from 'store/ducks/alert'
import * as appDuck from 'store/ducks/app'
import * as authenticationDuck from 'store/ducks/authentication'

import * as customize from 'store/ducks/customize'
import { intl } from 'i18n'
import { isHostNameMainDomain } from 'utils/customPage'
import { User } from 'interfaces/user'
import { GlobalState } from './state'

// Actions
export const CONFIRM_REQUEST = 'profile/CONFIRM_REQUEST'
export const CONFIRM_SUCCESS = 'profile/CONFIRM_SUCCESS'
export const CONFIRM_FAILURE = 'profile/CONFIRM_FAILURE'
export const FETCH_REQUEST = 'profile/FETCH_REQUEST'
export const FETCH_SUCCESS = 'profile/FETCH_SUCCESS'
export const FETCH_FAILURE = 'profile/FETCH_FAILURE'
export const AMEND_INFORMATIONS_REQUEST = 'profile/AMEND_INFORMATIONS_REQUEST'
export const AMEND_INFORMATIONS_SUCCESS = 'profile/AMEND_INFORMATIONS_SUCCESS'
export const AMEND_INFORMATIONS_FAILURE = 'profile/AMEND_INFORMATIONS_FAILURE'
export const AMEND_EMAIL_REQUEST = 'profile/AMEND_EMAIL_REQUEST'
export const AMEND_EMAIL_SUCCESS = 'profile/AMEND_EMAIL_SUCCESS'
export const AMEND_EMAIL_FAILURE = 'profile/AMEND_EMAIL_FAILURE'
export const AMEND_PHONE_REQUEST = 'profile/AMEND_PHONE_REQUEST'
export const AMEND_PHONE_SUCCESS = 'profile/AMEND_PHONE_SUCCESS'
export const AMEND_PHONE_FAILURE = 'profile/AMEND_PHONE_FAILURE'
export const AMEND_PASSWORD_REQUEST = 'profile/AMEND_PASSWORD_REQUEST'
export const AMEND_PASSWORD_SUCCESS = 'profile/AMEND_PASSWORD_SUCCESS'
export const AMEND_PASSWORD_FAILURE = 'profile/AMEND_PASSWORD_FAILURE'

export type ProfileState = {
  payload: User
  confirm: {
    loading: boolean
    confirmed: boolean
    errors: string[]
  }
  fetch: {
    loading: boolean
    errors: string[]
  }
  amend: {
    informations: {
      done: boolean
      loading: boolean
      errors: string[]
    }
    email: {
      done: boolean
      loading: boolean
      errors: string[]
    }
    phone: {
      done: boolean
      loading: boolean
      errors: string[]
    }
    password: {
      done: boolean
      loading: boolean
      errors: string[]
    }
  }
}

// Reducer
const INITIAL_STATE = {
  payload: {},
  confirm: {
    loading: false,
    confirmed: false,
    errors: [],
  },
  fetch: {
    loading: false,
    errors: [],
  },
  amend: {
    informations: {
      done: false,
      loading: false,
      errors: [],
    },
    email: {
      done: false,
      loading: false,
      errors: [],
    },
    phone: {
      done: false,
      loading: false,
      errors: [],
    },
    password: {
      done: false,
      loading: false,
      errors: [],
    },
  },
}

export function reducer(state: ProfileState = INITIAL_STATE, action) {
  switch (action.type) {
    case CONFIRM_REQUEST:
      return {
        ...state,
        confirm: {
          loading: true,
          confirmed: false,
          errors: [],
        },
      }

    case CONFIRM_SUCCESS:
      return {
        ...state,
        confirm: {
          loading: false,
          confirmed: true,
          errors: [],
        },
      }

    case CONFIRM_FAILURE:
      return {
        ...state,
        confirm: {
          loading: false,
          confirmed: false,
          errors: action.errors,
        },
      }

    case FETCH_REQUEST:
      return {
        ...state,
        fetch: {
          loading: true,
          errors: [],
        },
      }

    case FETCH_SUCCESS:
      return {
        ...state,
        payload: action.payload,
        fetch: {
          loading: false,
          errors: [],
        },
      }

    case FETCH_FAILURE:
      return {
        ...state,
        payload: {},
        fetch: {
          loading: false,
          errors: action.errors,
        },
      }

    case AMEND_INFORMATIONS_REQUEST:
      return {
        ...state,
        amend: {
          ...state.amend,
          informations: {
            done: false,
            loading: true,
            errors: [],
          },
        },
      }

    case AMEND_INFORMATIONS_SUCCESS:
      return {
        ...state,
        payload: action.payload,
        amend: {
          ...state.amend,
          informations: {
            done: true,
            loading: false,
            errors: [],
          },
        },
      }

    case AMEND_INFORMATIONS_FAILURE:
      return {
        ...state,
        amend: {
          ...state.amend,
          informations: {
            done: true,
            loading: false,
            errors: action.errors,
          },
        },
      }

    case AMEND_EMAIL_REQUEST:
      return {
        ...state,
        amend: {
          ...state.amend,
          email: {
            done: false,
            loading: true,
            errors: [],
          },
        },
      }

    case AMEND_EMAIL_SUCCESS:
      return {
        ...state,
        amend: {
          ...state.amend,
          email: {
            done: true,
            loading: false,
            errors: [],
          },
        },
      }

    case AMEND_EMAIL_FAILURE:
      return {
        ...state,
        amend: {
          ...state.amend,
          email: {
            done: true,
            loading: false,
            errors: action.errors,
          },
        },
      }

    case AMEND_PHONE_REQUEST:
      return {
        ...state,
        amend: {
          ...state.amend,
          phone: {
            done: false,
            loading: true,
            errors: [],
          },
        },
      }

    case AMEND_PHONE_SUCCESS:
      return {
        ...state,
        amend: {
          ...state.amend,
          phone: {
            done: true,
            loading: false,
            errors: [],
          },
        },
      }

    case AMEND_PHONE_FAILURE:
      return {
        ...state,
        amend: {
          ...state.amend,
          phone: {
            done: true,
            loading: false,
            errors: action.errors,
          },
        },
      }

    case AMEND_PASSWORD_REQUEST:
      return {
        ...state,
        amend: {
          ...state.amend,
          password: {
            done: false,
            loading: true,
            errors: [],
          },
        },
      }

    case AMEND_PASSWORD_SUCCESS:
      return {
        ...state,
        amend: {
          ...state.amend,
          password: {
            done: true,
            loading: false,
            errors: [],
          },
        },
      }

    case AMEND_PASSWORD_FAILURE:
      return {
        ...state,
        amend: {
          ...state.amend,
          password: {
            done: true,
            loading: false,
            errors: action.errors,
          },
        },
      }
    case authenticationDuck.LOGOUT_SUCCESS:
      return {
        ...state,
        payload: INITIAL_STATE.payload,
      }

    default:
      return state
  }
}

// Actions Creators
export const confirmRequest = (token, origin) => ({
  type: CONFIRM_REQUEST,
  token,
  origin,
})

export const confirmSuccess = () => ({
  type: CONFIRM_SUCCESS,
})

export const confirmFailure = (errors) => ({
  type: CONFIRM_FAILURE,
  errors,
})

export const fetchRequest = () => ({
  type: FETCH_REQUEST,
})

export const fetchSuccess = (payload) => ({
  type: FETCH_SUCCESS,
  payload,
})

export const fetchFailure = (errors) => ({
  type: FETCH_FAILURE,
  errors,
})

export const amendInformationsRequest = (payload) => ({
  type: AMEND_INFORMATIONS_REQUEST,
  payload,
})

export const amendInformationsSuccess = (payload) => ({
  type: AMEND_INFORMATIONS_SUCCESS,
  payload,
})

export const amendInformationsFailure = (errors) => ({
  type: AMEND_INFORMATIONS_FAILURE,
  errors,
})

export const amendEmailRequest = (email) => ({
  type: AMEND_EMAIL_REQUEST,
  email,
})

export const amendEmailSuccess = () => ({
  type: AMEND_EMAIL_SUCCESS,
})

export const amendEmailFailure = (errors) => ({
  type: AMEND_EMAIL_FAILURE,
  errors,
})

export const amendPhoneRequest = (phone) => ({
  type: AMEND_PHONE_REQUEST,
  phone,
})

export const amendPhoneSuccess = () => ({
  type: AMEND_PHONE_SUCCESS,
})

export const amendPhoneFailure = (errors) => ({
  type: AMEND_PHONE_FAILURE,
  errors,
})

export const amendPasswordRequest = () => ({
  type: AMEND_PASSWORD_REQUEST,
})

export const amendPasswordSuccess = () => ({
  type: AMEND_PASSWORD_SUCCESS,
})

export const amendPasswordFailure = (errors) => ({
  type: AMEND_PASSWORD_FAILURE,
  errors,
})

// Epics
export const epic = combineEpics(
  refreshTokenSuccessEpic,
  loginSuccessEpic,
  confirmRequestEpic,
  fetchRequestEpic,
  amendInformationsRequestEpic,
  amendEmailRequestEpic,
  amendPhoneRequestEpic,
  amendPasswordRequestEpic,
)

export function refreshTokenSuccessEpic(action$) {
  return action$
    .ofType(authenticationDuck.REFRESH_TOKEN_SUCCESS)
    .filter((action) => !action.retried)
    .mapTo(fetchRequest())
}

export function loginSuccessEpic(action$) {
  return action$.ofType(authenticationDuck.LOGIN_SUCCESS).map(() => fetchRequest())
}

export function confirmRequestEpic(action$) {
  return action$.ofType(CONFIRM_REQUEST).mergeMap((action) =>
    Observable.ajax(confirm({ params: { token: action.token, origin: action.origin } }))
      .mergeMap((res) =>
        Observable.of(
          confirmSuccess(),
          alertSuccess(intl.formatMessage({ id: 'ducks.register.confirm.success' })),
          authenticationDuck.logoutRequest(),
        ),
      )
      .catch((res) => Observable.of(confirmFailure(res.response.errors))),
  )
}

export function fetchRequestEpic(action$) {
  return action$.ofType(FETCH_REQUEST).mergeMap((action) => {
    if (!isHostNameMainDomain()) {
      return Observable.ajax(
        profile({
          params: {
            id: 'me',
          },
        }),
      )
        .mergeMap((res) => {
          return Observable.of(
            fetchSuccess(res.response),
            appDuck.readyApp(true),
            customize.initCustomizeInterface(res.response.managedCompany?.customPage),
          )
        })
        .catch((err) => {
          if (typeof err === 'object' && (err.response || {}).code === 401) {
            return Observable.of(authenticationDuck.refreshTokenRequest(action))
          }

          return Observable.of(fetchFailure(['Resource not found']), appDuck.readyApp(true))
        })
    } else {
      return Observable.of(appDuck.readyApp(true))
    }
  })
}

export function amendInformationsRequestEpic(action$) {
  return action$.ofType(AMEND_INFORMATIONS_REQUEST).mergeMap((action) =>
    Observable.ajax(
      amend.informations({
        params: {
          id: 'me',
        },
        payload: action.payload,
      }),
    )
      .mergeMap((res) =>
        Observable.of(
          amendInformationsSuccess(res.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.profile.amendInformations.success' })),
        ),
      )
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(amendInformationsFailure(['Resource not found']), alertErrorDefault())
      }),
  )
}

export function amendEmailRequestEpic(action$) {
  return action$.ofType(AMEND_EMAIL_REQUEST).mergeMap((action) =>
    Observable.ajax(amend.email({ payload: { email: action.email } }))
      .mergeMap((res) =>
        Observable.of(
          amendEmailSuccess(),
          alertSuccess(intl.formatMessage({ id: 'ducks.profile.amendEmail.success' })),
        ),
      )
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(amendEmailFailure(['Resource not found']), alertErrorDefault())
      }),
  )
}

export function amendPhoneRequestEpic(action$) {
  return action$.ofType(AMEND_PHONE_REQUEST).mergeMap((action) =>
    Observable.ajax(amend.phone({ payload: { phoneNumber: action.phone } }))
      .mergeMap((res) =>
        Observable.of(
          amendPhoneSuccess(),
          alertSuccess(intl.formatMessage({ id: 'ducks.profile.amendPhone.success' })),
        ),
      )
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(amendPhoneFailure(['Resource not found']), alertErrorDefault())
      }),
  )
}

export function amendPasswordRequestEpic(action$) {
  return action$.ofType(AMEND_PASSWORD_REQUEST).mergeMap((action) =>
    Observable.ajax(amend.password())
      .mergeMap((res) =>
        Observable.of(
          amendPasswordSuccess(),
          alertSuccess(intl.formatMessage({ id: 'ducks.profile.amendPassword.success' })),
        ),
      )
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(amendPasswordFailure(['Resource not found']), alertErrorDefault())
      }),
  )
}

export const selectProfile = (state: GlobalState) => state.profile.payload
